import { TFunction } from 'i18next';

import {
  formatDate,
  formatDateTime,
} from '~/modules/impacted-companies/components/utils';

type OptionsProps = {
  createdAt: string;
  updatedAt?: string;
  fy?: string;
  fq?: string;
  releasedDate?: string;
  isPreview: boolean;
  t: TFunction;
  isAnalyzing: boolean;
};

export const constructMetadataSentence = (options: OptionsProps): string => {
  const {
    createdAt,
    updatedAt,
    fy,
    fq,
    releasedDate,
    isPreview,
    t,
    isAnalyzing,
  } = options;

  if (isAnalyzing && releasedDate && fy && fq) {
    return t('earningsInsight.metadata.earningsAreBeingAnalyzed', {
      period: `${fq} ${fy}`,
      releasedDate: formatDate(new Date(releasedDate)),
    });
  }

  const parts: string[] = [];

  parts.push(
    t('earningsInsight.metadata.publishedWithDate', {
      date: formatDateTime(new Date(createdAt)),
    })
  );

  if (isPreview) {
    return parts.join('');
  }

  if (updatedAt) {
    parts.push(
      t('earningsInsight.metadata.updatedWithDate', {
        date: formatDateTime(new Date(updatedAt)),
      })
    );
  }

  if (fy && fq && releasedDate) {
    parts.push(
      t('earningsInsight.metadata.basedOnEarnings', {
        period: `${fq} ${fy}`,
        releasedDate: formatDate(new Date(releasedDate)),
      })
    );
  }

  return parts.join(' · ');
};
